import { render, staticRenderFns } from "./orderserviceitem.vue?vue&type=template&id=cac6c22a&scoped=true&"
import script from "./orderserviceitem.vue?vue&type=script&lang=js&"
export * from "./orderserviceitem.vue?vue&type=script&lang=js&"
import style0 from "./orderserviceitem.vue?vue&type=style&index=0&id=cac6c22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac6c22a",
  null
  
)

export default component.exports